import type { TenantConfig } from '@/types/TenantConfig'

const red = '#e31b23'
const darkGrey = '#212121'

export const pmns: TenantConfig = {
  logo: 'assets/pmns/static/logo.svg',
  themeOptions: {
    primaryColor: red,
    secondaryColor: red,
    logoHeight: '60px',
    headerHeight: '100px',
    headerBottomBorder: `1px solid black`,
    footerBackgroundColor: darkGrey,
    footerTextColor: 'white',
    cartHeaderBackgroundColor: darkGrey,
    memberLinksColor: darkGrey,
    memberLinksColorHover: 'black',
  },
  componentOptions: {
    citypassCoupons: {
      childKeywords: 'child, youth',
    },
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/pmns/static/complete.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
